module.exports = __webpack_public_path__ + "static/media/storeBanner.ec212de8.jpg";